<div [ngClass]="getChipClasses()">
  <mat-icon class="text-base ">{{ getIcon() }}</mat-icon>
  {{ status }}
</div>
